export default class AxImage {
  
  constructor(element) {
    this.element = element;
    this.handleScroll = this.handleScroll.bind(this);

    this.isVisible();
    this.handleScroll();
  }

  handleScroll() {
    window.addEventListener('scroll', () => {
      this.isVisible();
    });
  }


  isVisible() {
  const rect = this.element.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  const isVisible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  const hasClass = this.element.classList.contains('is-visible');

  // Clear any existing timeout to prevent multiple additions
  clearTimeout(this.visibilityTimeout);

  if (isVisible && !hasClass) {
    // Set a timeout to add the class after 300ms
    this.visibilityTimeout = setTimeout(() => {
      this.element.classList.add('is-visible');
    }, 100);
  } else if (!isVisible && hasClass) {
    // If element is not visible and has the class, remove it immediately without delay
    this.element.classList.remove('is-visible');
  }
}

}